module.exports = __webpack_public_path__ + "img/bg.f4631b98.jpg";